import { GeneralModel } from "./general.model";

export class PaymentCODType extends GeneralModel {
}